import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanySearchRegularAi from './company-search-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanySearchRegularAi {...validProps} />;
}
SvgComponent.iconName = 'companySearchRegularAi';

export const CompanySearchRegularAiIcon = svgIconWrapper(SvgComponent);
